import React from 'react';
import PropTypes from 'prop-types';
import { GAME_THEME } from '../../constants/GameTheme';



// Reusable SVG Component
const Target = ({ fill = GAME_THEME.TARGET_FILL, x = 0, y = 0, scale = 1, shots = [] }) => {
    const transform = `translate(${x}, ${y}) scale(${scale})`;

    return (
        <g transform={transform}>
            {/* Target Silhouette */}
            <path d="
                M 110 40
                H 190
                V 120
                H 260
                V 450
                H 40
                V 120
                H 110
                Z"
                fill={fill}
                stroke={GAME_THEME.TARGET_STROKE}
                strokeWidth={GAME_THEME.TARGET_STROKE_WIDTH}
            />

            {/* Target Zones */}
            <rect x="130" y="60" width="40" height="40" fill="none" stroke={GAME_THEME.TARGET_STROKE === 'white' ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.3)"} strokeDasharray="5,5" />
            <rect x="110" y="180" width="80" height="150" fill="none" stroke={GAME_THEME.TARGET_STROKE === 'white' ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.3)"} strokeDasharray="5,5" />
            <rect x="70" y="150" width="160" height="270" fill="none" stroke={GAME_THEME.TARGET_STROKE === 'white' ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.3)"} strokeDasharray="5,5" rx="10" />

            {/* Render shots if provided relative to this target */}
            {shots.map((s, i) => (
                <circle key={i} cx={s.x} cy={s.y} r="5" fill="#222" stroke="#fff" strokeWidth="1" />
            ))}
        </g>
    );
};

Target.propTypes = {
    fill: PropTypes.string,
    x: PropTypes.number,
    y: PropTypes.number,
    scale: PropTypes.number,
    shots: PropTypes.array
};

export default Target;
